<nav class="navbar navbar-expand-sm navbar-dark bg-dardk">
    <div class="container-fluid">
        <a class="navbar-brand pointer" routerLink="/home" routerLinkActive="router-link-active">
            <h1 class="display-4 red">Moviiiiiiiiiiiiies</h1>
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            </ul>
            <div class="d-flex">
                <input #text class="form-control me-2" type="search" placeholder="pelicula o serie" aria-label="Search" (key.up)="buscarPelicula( text.value )">
                <button class="btn btn-outline-success" type="submit" (click)="buscarPelicula( text.value )">Search</button>
            </div>
        </div>
    </div>
</nav>